import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "fill"]


export default /*@__PURE__*/_defineComponent({
  __name: 'CircleMarkSvg',
  props: {
  width: {
    type: [String, Number],
    default: 32,
  },
  height: {
    type: [String, Number],
    default: 32,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _mergeProps(_ctx.$attrs, {
    width: __props.width,
    height: __props.height,
    fill: __props.fill,
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }), [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }, null, -1)
  ]))], 16, _hoisted_1))
}
}

})